<template>
  <div class="clearfix">
    <div class="container my-5">
      <div class="row">
        <div class="col-md-12">
          <br>
          <br>
          <h2 class="text-dark">Descarga los siguientes documentos:</h2>
          <br>
          <br>
          <b-button href="/docs/17-OIN-056_Alcance_2024.pdf">RESOLUCIÓN DE ONAC CON LOS NUEVOS ALCANCES DE RETIE 2024</b-button>
          <br>
          <br>
          <b-button href="/docs/Resolucion_40117-02-04-24-Reglamento_Teecnico-RETIE.pdf">NUEVO REGLAMENTO RESOLUCIÓN 40117 DE 2 DE ABRIL DE 2024</b-button>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Documentos',
  mounted () {
    this.$store.commit('setActualPage', 'Documentos de Consulta')
  }
}
</script>

<style>
</style>
